export function toggleSideBar () {
  return (dispatch, getState) => {
    const state = getState()
    const show = state.sideBar.showSideBar
    dispatch({
      type: 'TOGGLE_SIDE_BAR',
      show: !show
    })
  }
};

export function setComponent (component) {
  return (dispatch) => {
    dispatch({
      type: 'SET_COMPONENT',
      component
    })
  }
};

export function hideSideBar () {
  return (dispatch) => {
    dispatch({ type: 'HIDE_SIDE_BAR' })
  }
};

export function displaySideBar () {
  return (dispatch) => {
    dispatch({ type: 'SHOW_SIDE_BAR' })
  }
};
